module.exports = __webpack_public_path__ + "media/images/pc/special_reports/icon_leaf2-f9cf181c8bb33b21ec284337cf3ac57a.png";